export class CompanyConsentModel {
  id: number;
  content: string;
  companyName: string;
  type:
    | 'VINLIVT_TERMS_OF_USE_CLIENT'
    | 'VINLIVT_PRIVACY_CLIENT'
    | 'PARTNER_PRIVACY_CLIENT'
    | 'PARTNER_INITIAL_INFORMATION';
}
